import React from 'react'
import {MdPriorityHigh} from 'react-icons/md'


export default class IconMissing extends React.Component {
  render() {
    return (
      <MdPriorityHigh {...this.props} />
    )
  }
}
